import {
  GET_WEB_BUILDER_DATA,
  GET_WEB_BUILDER_DATA_SUCCESS,
  GET_WEB_BUILDER_DATA_ERROR,
  UPDATE_WEB_BUILDER_STATE,
  HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION,
  HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION_SUCCESS,
  HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION_ERROR,
  SAVE_DESIGNER_DATA,
  SAVE_DESIGNER_SUCCESS,
  SAVE_DESIGNER_ERROR
} from "../actions";

export const saveDesignerData = (webBuilderData) => {
  return {
    type: SAVE_DESIGNER_DATA,
    payload: { webBuilderData }
  };
};

export const saveDesignerDataSuccess = (webBuilderData) => ({
  type: SAVE_DESIGNER_SUCCESS,
  payload: webBuilderData,
});

export const saveDesignerDataError = (message) => ({
  type: SAVE_DESIGNER_ERROR,
  payload: { message },
});

export const getWebBuilderData = (collectionItemId, nodeId, isRendering, activityInfo) => {
  return {
    type: GET_WEB_BUILDER_DATA,
    payload: { collectionItemId, nodeId, isRendering, activityInfo }
  };
};

export const getWebBuilderDataSuccess = (webBuilderData) => ({
  type: GET_WEB_BUILDER_DATA_SUCCESS,
  payload: webBuilderData,
});

export const getWebBuilderDataError = (message) => ({
  type: GET_WEB_BUILDER_DATA_ERROR,
  payload: { message },
});

export const updateWebBuilderState = (newState) => {
  return {
    type: UPDATE_WEB_BUILDER_STATE,
    payload: newState,
  };
};

export const handleChangeOnCollectionItemOption = (isSelected, collectionItemOption, collectionItemId) => {
  return {
    type: HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION,
    payload: { isSelected, collectionItemOption, collectionItemId },
  };
};

export const handleChangeOnCollectionItemOptionSuccess = (selectedCollectionItemOptions) => ({
  type: HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION_SUCCESS,
  payload: { selectedCollectionItemOptions },
});

export const handleChangeOnCollectionItemOptionError = (message) => ({
  type: HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION_ERROR,
  payload: { message },
});